import styled from 'styled-components';
import StyledSelect from 'components/ui/StyledSelect';
import { Row } from 'components/shared/Layout';
import { ConfirmButton } from 'components/ui/Button';

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px 0;
`;

const StyledButton = styled.button.attrs({ type: 'button' })`
  border: none;
  text-decoration: underline;
  outline: none;
  cursor: pointer;
  padding: 0;
  line-height: 24px;
`;

const StyledDropdown = styled(StyledSelect)`
  height: 32px;
  margin-top: 16px;
`;

const StyledLabel = styled.label`
  margin-top: 16px;
  margin-bottom: 8px;
`;

const StyledTextarea = styled.textarea`
  resize: none;
`;

const StyledHeading = styled.h1`
  margin: 0;
`;

const StyledOverrideTitleRow = styled(Row)`
  width: 100%;
`;

const StyledApplyButton = styled(ConfirmButton)`
  margin: 0;
`;

const StyledWaiveFees = styled.div`
  font-weight: 600;
  margin: 20px 0;
`;

export {
  StyledForm,
  StyledButton,
  StyledDropdown,
  StyledLabel,
  StyledTextarea,
  StyledHeading,
  StyledOverrideTitleRow,
  StyledApplyButton,
  StyledWaiveFees
};
